import {requirePermission} from '@/modules/auth/permissions'
import {useGetActiveSubstanceDrug} from '@/modules/drug-catalog/substances/api/use-get-active-substance-drug'
import {ActiveSubstanceForm} from '@/modules/drug-catalog/substances/components'
import {EditResourceTitle} from '@/shared/components/ui/edit-resource-title'
import {NewActiveSubstancePageSearchSchema} from '@/modules/drug-catalog/substances/schemas'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/configuration/drug-catalog/active-substances/new')({
  beforeLoad: requirePermission('catalogue.manage'),
  component: NewActiveSubstancePage,
  validateSearch: NewActiveSubstancePageSearchSchema,
})

function NewActiveSubstancePage() {
  const {t} = useTranslate('substances')
  const {substanceId} = Route.useSearch()
  const [substance] = useGetActiveSubstanceDrug(substanceId)

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader
        title={
          substanceId ? (
            <EditResourceTitle label={t('edit_substance_title')} name={substance?.name} />
          ) : (
            t('new_substance_title')
          )
        }
        description={t('new_substance_description')}
      />

      <ActiveSubstanceForm substanceId={substanceId} />
    </NewResourceFormContainer>
  )
}
